
<div ngbAutofocus class="modal-header blue">
    <div class="container-fluid">
        <div class="row modal-header-row">
            <img class="modal-icon" src="assets/ico/exclamation-triangle-regular.svg" alt="icon">
            <span class="modal-title" id="modal-basic-title">{{'modals.header.confirmAction' | translate}}</span>
        </div>
    </div>
</div>
<div class="modal-body">
    <p class="mb-0">{{message | translate}}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn modal-btn" (click)="close()">{{'modals.buttons.no' | translate | uppercase}}</button>
    <button type="button" class="btn modal-btn" (click)="confirm()">{{'modals.buttons.yes' | translate | uppercase}}</button>
</div>